<template>
  <div id="sac-select-container" :class="[containerClass || '']" :style="{ width }">
    <div class="flex-row">
      <select
        aria-label="sac-select"
        :class="[
          'sac-select',
          !value ? 'placeholder' : '',
          selectClass || '',
          backgroundColor,
        ]"
        :style="{ backgroundColor }"
        @change="change($event.target.value)"
      >
        <option v-for="(option, idx) of options" :key="idx" :value="option.value" :selected="value === option.value">
          {{ option.label }}
        </option>
      </select>
      <img alt="Down" src="@shared/assets/img/general/chevron-down.png" class="chevron-down">
    </div>
    <span v-if="error" class="error-text">
      {{ error }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'SACSelect',
  props: {
    value: [String, Number],
    options: Array,
    change: Function,
    selectClass: String,
    containerClass: String,
    error: String,
    backgroundColor: {
      type: String,
      default: '#FFFFFF',
    },
    width: {
      type: String,
      default: '330px',
    },
  },
};
</script>

<style lang="scss" scoped>
#sac-select-container {
  position: relative;
  .sac-select {
    height: 40px;
    padding: 0 35px 0 9px;
    border-radius: 2px;
    font-size: 12.64px;
    width: 100%;
    text-overflow: ellipsis;

    &.placeholder {
      color: $N50;
    }
  }
  .chevron-down {
    position: absolute;
    top: 45%;
    right: 15px;
    width: 8px;
    height: 4px;
  }
  .error-text {
    font-size: 0.75rem;
    color: $TOMATO100;
    padding-left: 8px;
  }
}
</style>
